<template>
  <div v-loading="loading">
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="1200"
        :row-class-name="tableRowClassName"
        style="width: 100%">
      <el-table-column
          align="center"
          prop="areaName"
          label="地区">
      </el-table-column>
      <el-table-column
          align="center"
          prop="sumCapacity"
          label="焦化产能（万吨/年）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="proportion"
          label="产能占比%">
      </el-table-column>
    </el-table>
    <div class="echarts">
      <div id="myChart" style="width: 1100px;height:340px;"></div>
    </div>
  </div>
</template>

<script>
import {getListRegionalDistribution} from '@/api/coke'
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      option : {
        title: {
          // text: "全国焦化产能区域分布",
          padding: [0,20,150,80],
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ["2019", '2020', '2021']
        },
        xAxis: {
           padding: [0,20,150,80],
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
          axisLabel: {
		rotate: 45, //代表逆时针旋转
    interval: 0
	}
        },
        yAxis: {
          name: '产能',
          type: 'value',
        },
        series: [
          {
            type: "bar",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#F26D77' //改变折线颜色
            },
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    color: 'black',
                    fontSize: 14
                  }
                }
              }
            }
          },
        ],
        grid: {
          x: 100,
          y: 50,
          x2: 10,
          y2: 90
        },
      },
      areaList:[],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getListRegionalDistribution().then(res => {
        this.tableData = res.data.list;
        this.option['xAxis']['data'] = res.data['provinceList'];
        this.option['series'][0]['data'] = res.data['numberList'];
        this.areaList = res.data['areaNameList'];
        this.drawChart();
        this.loading = false
      })
    },
    tableRowClassName({row}) {
      if (this.areaList.includes(row['areaName'])) {
        return 'warning-row';
      } else {
        return '';
      }
    },
    /**
     * 选择地图
     */
    chooseEchars(row) {
      console.log(row)
    },
    /**
     * 加载地图
     */
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(this.option);
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
.slot-span {
  display: inline-block;
  text-align: center;
  line-height: 25px;
  width: 74px;
  height: 25px;
  background: #F2F2F2;
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  cursor: pointer;
}

.echarts {
  margin-top: 24px;
  width: 1200px;
  height: 400px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
  padding: 30px;
}
</style>
